import styled from "styled-components";

export const Input = styled.div`
  margin-bottom: 0.4rem;
  margin-top: 0px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 12px !important;

  label {
    margin-left: 2px;
    font-weight: 500;
    color: var(--neutral-700);
  }

  .select {
    width: 100%;
    margin-left: 0.1rem;
  }

  .placeholderSelect {
    font-size: 12px;
    color: var(--color-input-placeholder);
    text-align: left;
    font-weight: 400;
  }
`;

export const Error = styled.div`
  font-size: 10px;
  color: #dc2229;
  margin-top: 0.2rem;
`;
